module.exports = __webpack_public_path__ + "static/media/Tw-Cen-MT.f7d57055.svg";